function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import PropTypes from "prop-types";
import Geo from "@xo-union/sdk-geo";
var Context = /*#__PURE__*/React.createContext(null);
var CanSpamLoader = function CanSpamLoader(_ref) {
  var geoClient = _ref.geoClient,
    children = _ref.children;
  var _React$useState = React.useState({
      ready: false,
      requireExplicitOptin: false
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    state = _React$useState2[0],
    setState = _React$useState2[1];
  var isMounted = React.useRef(false);
  React.useEffect(function () {
    isMounted.current = true;
    geoClient.geoByClientIP({
      country_only: true
    }).then(function (response) {
      if (!isMounted.current) {
        return;
      }
      var countryCode = response.body.countryCode;
      setState({
        ready: true,
        requireExplicitOptin: countryCode !== 'US'
      });
    })["catch"](function () {
      if (!isMounted.current) {
        return;
      }
      setState({
        ready: true,
        requireExplicitOptin: true
      });
    });
    return function () {
      isMounted.current = false;
    };
  }, [geoClient]);
  var finalChildren = typeof children === 'function' ? children(state) : children;
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: state
  }, finalChildren);
};
process.env.NODE_ENV !== "production" ? CanSpamLoader.propTypes = {
  geoClient: PropTypes.shape({
    geoByClientIP: PropTypes.func
  }).isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired
} : void 0;

/**
 *
 * This component handles country-specific spam laws by wrapping the logic to determine if the user should be automatically opted into marketing emails or if we require explicit optin.  The SignUp form depends on the data that's being provided by this component in order to conditionally display the email optin checkbox.
 * Ideally, you would mount this once at the root of the application (if you need to support sign up flow) as this makes a request to the Geo API to get the user's IP address.  Nested `CanSpam`s are allowed and will not result in duplicate requests.  Sibling `CanSpamProvider`s, however, will result in multiple requests to Geo API.
 *
 * #### Shared Context
 *
 * | Property              | Description                                    | Type  | Default |
 * |-----------------------------------------------------------------------------------------|
 * |`requireExplicitOptin`|Does user require explicit optin to TK emails?  | `bool`| `false`  |
 * |`ready`               |Has Geo API request completed? (success/failure)| `bool`| `false` |
 *
 */
var CanSpam = function CanSpam(_ref2) {
  var children = _ref2.children,
    geoClient = _ref2.geoClient;
  var canSpamState = React.useContext(Context);
  if (canSpamState) {
    return typeof children === 'function' ? children(canSpamState) : children;
  }
  return /*#__PURE__*/React.createElement(CanSpamLoader, {
    geoClient: geoClient
  }, children);
};
process.env.NODE_ENV !== "production" ? CanSpam.propTypes = {
  /**
   * Children or render function. The render function will receive the shared context as an argument
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  /**
   * Geo client from `@xo-union/sdk-geo`
   */
  geoClient: PropTypes.shape({
    geoByClientIP: PropTypes.func.isRequired
  })
} : void 0;
CanSpam.defaultProps = {
  geoClient: new Geo()
};
export default CanSpam;